import { render, staticRenderFns } from "./oilDetails.vue?vue&type=template&id=961ec358&scoped=true&"
import script from "./oilDetails.vue?vue&type=script&lang=js&"
export * from "./oilDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "961ec358",
  null
  
)

export default component.exports